import { createReducer } from '@reduxjs/toolkit'
import { Actions_Bookings } from './Actions'
import { IStateBookings } from './TReducer'

const initialState: IStateBookings = {
  isLoading: false,
  data: null,
  responseInfo: null,
  isAllDataLoaded: false,
  filters: {
    limit: 30,
    offset: 0,
    fromDate: null,
    toDate: null,
    searchStr: '',
  },
  pickUpParkings: [],
  selectedPickUpParking: null,
  selectedTrailerTypeId: null,
  currentBooking: null,
}

const ReducerTrackerCodes = createReducer(initialState, (builder) => {
  builder
    .addCase(Actions_Bookings.store.showLoader, (state) => {
      state.isLoading = true
    })
    .addCase(Actions_Bookings.store.hideLoader, (state) => {
      state.isLoading = false
    })
    .addCase(Actions_Bookings.store.saveBookings, (state, action) => {
      const payload = action.payload
      return { ...state, ...payload }
    })
    .addCase(Actions_Bookings.store.changeFilter, (state, action) => {
      state.filters = action.payload
    })
    .addCase(Actions_Bookings.store.increaseFilterOffset, (state, action) => {
      state.filters = action.payload
    })
    .addCase(Actions_Bookings.store.reset, () => {
      return initialState
    })
    .addCase(Actions_Bookings.store.savePickUpParkings, (state, action) => {
      state.pickUpParkings = action.payload
    })
    .addCase(Actions_Bookings.store.setSelectedPickUpParking, (state, action) => {
      state.selectedPickUpParking = action.payload
    })
    .addCase(Actions_Bookings.store.setSelectedTrailerTypeId, (state, action) => {
      state.selectedTrailerTypeId = action.payload
    })
    .addCase(Actions_Bookings.store.setCurrentBooking, (state, action) => {
      const payload = action.payload
      state.currentBooking = payload
    })
})

export default ReducerTrackerCodes
